module.exports = __webpack_public_path__ + "img/flama_off.3dcc7a6d.png";